import { Injectable } from "@angular/core";
import { Jurisdiction } from "@obg/ngx.core";
import { DeviceType } from "@obg/ngx.global";
import { forEach, head, map as lodashMap, unescape } from "lodash-es";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { ContentClient } from "../content/content.client";
import { ContentDocument } from "../content/content.model";
import { MetadataDeviceType } from "../model";
import { getDeviceTypeFromMeta } from "../util";

import { Icon, IconResponse } from "./icon.model";

@Injectable({
	providedIn: "root",
})
export class IconService {
	constructor(private client: ContentClient) {}
	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentValue.getIcons_v2)" instead
	 */
	getAll(deviceType: DeviceType, jurisdiction: Jurisdiction): Observable<Record<string, Icon[]>> {
		const filterByDevice = (icon: ContentDocument<IconResponse>) => {
			const userDeviceType = getDeviceTypeFromMeta(deviceType);
			const metaDeviceType = icon.content?.metadata?.deviceType;

			return (
				metaDeviceType === undefined ||
				metaDeviceType.length === 0 ||
				metaDeviceType.some((type) => type === MetadataDeviceType.Any || type === userDeviceType)
			);
		};

		const filterByJurisdiction = (icon: ContentDocument<IconResponse>) => {
			const metaJurisdiction = icon.content?.metadata?.jurisdiction;

			return (
				metaJurisdiction === undefined ||
				metaJurisdiction.length === 0 ||
				metaJurisdiction.some((jur) => ["any", jurisdiction.toLowerCase()].includes(jur.toLocaleLowerCase()))
			);
		};

		return this.client.getIcons().pipe(
			map((response) => {
				const icons: Record<string, Icon[]> = {};
				forEach(response.documents, (rawIcons, documentType) => {
					rawIcons = rawIcons.filter((icon) => filterByDevice(icon) && filterByJurisdiction(icon));
					icons[documentType] = lodashMap(rawIcons, this.processRawIcon);
				});
				return icons;
			})
		);
	}

	private processRawIcon(rawIcon: ContentDocument<IconResponse>): Icon {
		const label = head(rawIcon.content?.label);
		const route = head(rawIcon.content?.route);
		const state = head(rawIcon.content?.metadata?.state);
		const visualTag = head(rawIcon.content?.metadata?.visualTag);
		const link = head(rawIcon.content?.link);
		const userState = head(rawIcon.content?.metadata?.userState);

		// todo: OBGB-2005 remove unescaping
		if (link?.url) {
			link.url = unescape(link.url);
		}

		return {
			key: rawIcon.documentKey,
			logo: head(rawIcon.content?.logo),
			state,
			userState,
			link,
			route,
			label: label || "",
			visualTag,
		};
	}
}
